import styled from 'styled-components';
import BubblesSlider from './BubblesSlider';
import { StyledNavLink } from './NavigationItem';

const BubblesSliderSmall = styled(BubblesSlider)`
    ${StyledNavLink} {
        height: 35px;
        margin: 0 6px 0 0;
        font-size: 0.86em;
    }
`;

export default BubblesSliderSmall;

export { BubblesSliderProps, CenteredBubblesSliderWrapper } from './BubblesSlider';
